import { render, staticRenderFns } from "./GoodsColumnsComponent.vue?vue&type=template&id=cce44802&scoped=true&"
import script from "./GoodsColumnsComponent.vue?vue&type=script&lang=js&"
export * from "./GoodsColumnsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce44802",
  null
  
)

export default component.exports